import { useEffect, useState } from "react";
import api from "../../services/api";

const COLORS = {
  primary: "#0D47A1",
  profit: "#16A34A",
  danger: "#D32F2F",
  bg: "#FFF6EA",
  card: "#FFFFFF",
  border: "#E0E0E0",
  text: "#1E1E1E",
  muted: "#757575",
};

const Ledger = () => {

  const [parties,setParties] = useState([]);
  const [selected,setSelected] = useState(null);
  const [rows,setRows] = useState([]);

  /* LOAD PARTIES */

  const loadParties = async () => {

    try{
      const res = await api.get("/parties/list.php");
      setParties(res.data?.data || []);
    }catch(err){
      console.error(err);
    }

  };

  useEffect(()=>{
    loadParties();
  },[]);

  /* LOAD LEDGER */

  const loadLedger = async (party) => {

    if(!party) return;

    try{

      setSelected(party);

      const res = await api.get(
        `/ledger/list.php?party_id=${party.id}`
      );

      setRows(res.data?.data || []);

    }catch(err){
      console.error(err);
    }

  };

  return(

    <div style={styles.page}>

      {/* HEADER */}

      <div style={styles.header}>

        <div>
          <h2 style={styles.title}>Ledger</h2>

          <div style={styles.subtitle}>
            View account transactions
          </div>
        </div>

      </div>

      {/* PARTY SELECT */}

      <select
        value={selected?.id || ""}
        onChange={(e)=>{

          const party = parties.find(
            p=>String(p.id)===String(e.target.value)
          );

          loadLedger(party);

        }}
        style={styles.input}
      >

        <option value="">Select Party</option>

        {parties.map(p=>(
          <option key={p.id} value={p.id}>
            {p.name}
          </option>
        ))}

      </select>

      {/* LEDGER TABLE */}

      {rows.length > 0 && (

        <div style={styles.card}>

          <div style={styles.tableWrap}>

            <table style={styles.table}>

              <thead>

                <tr>

                  <th style={styles.th}>Date</th>
                  <th style={styles.th}>Particular</th>

                  {selected?.type !== "customer" && (
                    <th style={styles.th}>Debit</th>
                  )}

                  {selected?.type !== "supplier" && (
                    <th style={styles.th}>Credit</th>
                  )}

                  <th style={styles.th}>Balance</th>

                </tr>

              </thead>

              <tbody>

                {rows.map((r,i)=>(

                  <tr key={i}>

                    <td style={styles.td}>
                      {r.date}
                    </td>

                    <td style={styles.td}>
                      {r.type}
                    </td>

                    {selected?.type !== "customer" && (

                      <td style={{
                        ...styles.td,
                        color:COLORS.danger
                      }}>

                        {r.debit>0 ? `₹ ${Number(r.debit).toFixed(2)}` : ""}

                      </td>

                    )}

                    {selected?.type !== "supplier" && (

                      <td style={{
                        ...styles.td,
                        color:COLORS.profit
                      }}>

                        {r.credit>0 ? `₹ ${Number(r.credit).toFixed(2)}` : ""}

                      </td>

                    )}

                    <td style={{
                      ...styles.td,
                      fontWeight:600
                    }}>

                      ₹ {Number(r.balance).toFixed(2)}

                    </td>

                  </tr>

                ))}

              </tbody>

            </table>

          </div>

        </div>

      )}

    </div>

  );

};

/* ================= RESPONSIVE STYLES ================= */

const styles = {

  page:{
    background:COLORS.bg,
    padding:"20px clamp(15px,4vw,30px)",
    minHeight:"100vh"
  },

  header:{
    marginBottom:20,
    display:"flex",
    flexWrap:"wrap",
    gap:10
  },

  title:{
    fontSize:26,
    fontWeight:700
  },

  subtitle:{
    color:COLORS.muted
  },

  input:{
    width:"100%",
    padding:10,
    borderRadius:6,
    border:`1px solid ${COLORS.border}`,
    marginBottom:20,
    boxSizing:"border-box"
  },

  card:{
    background:COLORS.card,
    borderRadius:12,
    border:`1px solid ${COLORS.border}`,
    padding:20
  },

  tableWrap:{
    overflowX:"auto"
  },

  table:{
    width:"100%",
    borderCollapse:"collapse",
    minWidth:600
  },

  th:{
    textAlign:"left",
    padding:12,
    borderBottom:`1px solid ${COLORS.border}`
  },

  td:{
    padding:12,
    borderBottom:`1px solid ${COLORS.border}`
  }

};

export default Ledger;